import * as S from './styles';

interface PricingToggleProps {
	isYearly: boolean;
	onChange: (isYearly: boolean) => void;
}

const PricingToggle = ({ isYearly, onChange }: PricingToggleProps) => {
	return (
		<S.Wrapper>
			<S.Toggle>
				<S.Indicator $isYearly={isYearly} />
				<S.Option $active={!isYearly} onClick={() => onChange(false)}>
					Monthly
				</S.Option>
				<S.Option $active={isYearly} onClick={() => onChange(true)}>
					Yearly
				</S.Option>
			</S.Toggle>
		</S.Wrapper>
	);
};

export default PricingToggle;
